import React, { useState } from 'react';

type AdminProps = {
  logout: () => void;
};

export default function AdminPage({ logout }: AdminProps) {
  const [status, setStatus] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleSendInvite = async () => {
    setLoading(true);
    setStatus(null);
    try {
      const response = await fetch(
        'https://lab4invitebuttonbackendimplementation-cvgmdqdpcpdxcyde.westeurope-01.azurewebsites.net/api/invite',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({}),
        }
      );

      const result = await response.json();

      if (response.ok) {
        setStatus(
          `✅ The invitation was sent!\n\nNow browse to: https://myapplications.microsoft.com/?tenantid=e4c790e0-7ef9-445e-8374-a2a846e9bf0a\nand sign in as: BrotenantUser@bigbankorggmail.onmicrosoft.com to access BroTenant as a Guest.`
        );
      } else {
        setStatus(`❌ Failed to send invite: ${result?.error || 'Unknown error'}`);
      }
    } catch (err) {
      setStatus(`❌ Request failed: ${err}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h1>Admin Dashboard</h1>
      <p>Only users with 'admin' in their email claim can access this page.</p>

      <button onClick={logout} style={{ marginBottom: '1rem' }}>
        Logout
      </button>

      <div>
        <button onClick={handleSendInvite} disabled={loading}>
          {loading ? 'Sending...' : 'Send Guest Invitation'}
        </button>
      </div>

      {status && (
        <pre style={{ marginTop: '1rem', whiteSpace: 'pre-wrap', color: status.startsWith('✅') ? 'green' : 'red' }}>
          {status}
        </pre>
      )}
    </div>
  );
}
